import React from 'react';
import { connect } from 'react-redux';

import Input from '@components/Input';

import { setPanelLYH } from '@reducers/options/panel/actions';
import { unitLabel, unitTransform } from '@services/helper.service';
import { defaultUnits } from '@config';

const Lyh = props => {
  if (props.isLyh) {
    return (
      <Input
        prefix="Lyh ="
        postfix={unitLabel(props.unit)}
        className="base-plate__input_block"
        id="lyh"
        type="number"
        minValue={0}
        disabled={props.predefinedBasePlate && props.predefinedBasePlate.isPredefinedBasePlate}
        value={props.lyhValue || 0}
        onUpdate={value => {
          props.setLyh(value, props.unit);
        }}
      />
    );
  }

  return null;
};

const mapState = state => {
  const unit = state.main.units.distance;

  if (state.options.panel.lyh) {
    return {
      isLyh: state.options.panel.lyh.active,
      lyhValue: unitTransform(state.options.panel.lyh.value).from(defaultUnits.DISTANCE).to(unit),
      unit,
      predefinedBasePlate: state.selectors.application[state.main.appType].predefinedBasePlate
    };
  }
  else 
    return {}; // mapStateToProps() in Connect(Lyh) must return a plain object. Instead received undefined.
};

const mapDispatch = dispatch => ({
  setLyh: (value, unit) => dispatch(setPanelLYH({
    value: unitTransform(+value, false).from(unit).to(defaultUnits.DISTANCE)
  })),
});

export default connect(mapState, mapDispatch)(Lyh);



// WEBPACK FOOTER //
// ./src/views/Dimension/components/BasePlate/Lyh.js